import { useEffect } from 'react';

export default function Seo({ title, description }) {
  useEffect(() => {
    if (title) document.title = `${title} — St-Louis.io`;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
    // basic Open Graph
    const setOg = (p, v) => {
      let tag = document.querySelector(`meta[property="og:${p}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', `og:${p}`);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', v);
    };
    if (title) setOg('title', title);
    if (description) setOg('description', description);
  }, [title, description]);
  return null;
}


